import moment from 'moment';
import { initialMarksMap } from '../../constants/marks';
import { initialRatingsMap } from '../../constants/ratings';
import { roundPercent } from '../roundPercent';
import { generateHouses } from './generateHouses';
import { generateMarks } from './generateMarks';
import { generateParentServices } from './generateParentServices';
import { generateRegions } from './generateRegions';
import { generateRequestsByDate } from './generateRequestsByDate';
import { generateServices } from './generateServices';
import { generateRatings } from './geterateRating';
import { generateRequestsCounts } from '../generateRequestsCounts';
import { generateWorkers } from './generateWorkers';

const getAverageValue = (divident, divider, mathNum = 10) => {
  const num = divident / divider;

  const average = Math.floor(num * mathNum) / mathNum;

  if (isNaN(average)) {
    return 0;
  }

  if (average === 0) {
    return 0.01;
  }

  return average;
};

const getItemsWithPercentAndAverageValues = ({
  requestsCount,
  items = [],
  withAverageValues = false,
}) => {
  const result = Array.isArray(items) ? items : Array.from(items.values());

  if (withAverageValues) {
    return result.map((item) => {
      if (requestsCount > 0) {
        item.percent = roundPercent(item.value / requestsCount);
      }

      item.averageRating = getAverageValue(item.rating, item.ratingCount);
      item.averageLifetime = getAverageValue(
        item.lifetime,
        item.doneCount,
        100
      );

      return item;
    });
  } else if (requestsCount > 0) {
    return result.map((item) => {
      item.percent = roundPercent(item.value / requestsCount);
      return item;
    });
  } else {
    return result;
  }
};

export const getChartsData = (requests) => {
  const mastersMap = new Map();
  const executersMap = new Map();
  const parentServicesMap = new Map();
  const servicesMap = new Map();
  const housesMap = new Map();
  const marksMap = new Map(initialMarksMap);
  const regionsMap = new Map();
  const ratingsMap = new Map(initialRatingsMap);
  const requestsByDateMap = new Map();

  const counts = {
    active: 0,
    immediate: 0,
    expired: 0,
    retry: 0,
    chargeable: 0,
    done: 0,
    totalRequestLifetime: 0,
  };

  requests.forEach((request) => {
    generateWorkers(request, mastersMap, 'master');
    generateWorkers(request, executersMap, 'executer');
    generateParentServices(request, parentServicesMap);
    generateServices(request, servicesMap);
    generateHouses(request, housesMap);
    generateMarks(request, marksMap);
    generateRegions(request, regionsMap);
    generateRatings(request, ratingsMap);
    generateRequestsByDate(request, requestsByDateMap);
    generateRequestsCounts(request, counts);
  });

  const requestsCount = requests.length;

  const masters = getItemsWithPercentAndAverageValues({
    requestsCount,
    items: mastersMap,
    withAverageValues: true,
  });

  const executers = getItemsWithPercentAndAverageValues({
    requestsCount,
    items: executersMap,
    withAverageValues: true,
  });

  const marks = getItemsWithPercentAndAverageValues({
    requestsCount,
    items: marksMap,
  });

  const regions = getItemsWithPercentAndAverageValues({
    requestsCount,
    items: regionsMap,
    withAverageValues: true,
  });

  const ratings = getItemsWithPercentAndAverageValues({
    requestsCount,
    items: ratingsMap,
  });

  const num = counts.totalRequestLifetime / counts.done;
  const averageLifetime = Math.floor(num * 100) / 100;

  const requestsCounts = {
    all: requests.length,
    active: counts.active,
    immediate: counts.immediate,
    expired: counts.expired,
    retry: counts.retry,
    chargeable: counts.chargeable,
    averageLifetime,
  };

  return {
    masters,
    executers,
    parentServices: Array.from(parentServicesMap.values()),
    services: Array.from(servicesMap.values()),
    houses: Array.from(housesMap.values()),
    marks,
    regions,
    ratings,
    requestsByDate: Array.from(requestsByDateMap.values()).sort(
      (a, b) => moment(a.name, 'DD-MM-YYYY') - moment(b.name, 'DD-MM-YYYY')
    ),
    requestsCounts,
  };
};
